import cloneDeep from 'lodash/cloneDeep';

export function getLogDataFromUserContext(userContext) {
    const {
      brand,
      subBrand,
      langISO2,
      offering,
      publicationId,
      countryISO3,
      currency
    } = cloneDeep(userContext);
    return {
      brand,
      subBrand,
      langISO2,
      offering,
      publicationId,
      countryISO3,
      currency
    };
  }